import { Block } from 'modules/trainings/lib/content/Block'

import { GQLContentBlock } from './types'

/**
 * Base error class for all mapper-related errors
 */
class MapperError extends Error {
  constructor(message: string, public readonly context: Record<string, unknown>) {
    super(message)
    this.name = this.constructor.name
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    }
  }
}

/**
 * Thrown when no mapper is registered for a given GraphQL or domain type
 */
export class UnregisteredMapperError extends MapperError {
  constructor(typename: string, registeredTypes: string[]) {
    super(`No mapper registered for type: ${typename}`, {
      typename,
      registeredTypes,
    })
  }
}

/**
 * Thrown when a mapper fails to transform data
 */
export class MapperTransformationError extends MapperError {
  constructor(typename: string, reason: string, data: GQLContentBlock | Block) {
    super(`Failed to transform ${typename}: ${reason}`, {
      typename,
      reason,
      data,
    })
  }
}

/**
 * Thrown when required data is missing or invalid
 */
export class InvalidBlockDataError extends MapperError {
  constructor(typename: string, missingField: string, data: GQLContentBlock) {
    super(`Invalid block data for ${typename}: missing or invalid field '${missingField}'`, {
      typename,
      missingField,
      data,
    })
  }
}
